<template>
  <div class="modular">
    <div class="radiobox">
      <div class="radio">
        <el-radio v-model="radio" :label="1">表格</el-radio>
      </div>
    </div>
    <div v-show="radio === 1" v-loading="chartLoading">
      <div class="top">
        <el-row>
          <el-col :span="8">
            <div class="conent">
              <div class="title danger">紧急</div>
              <div class="value">{{count.alert}}<span class="unit">个</span></div>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="conent">
              <div class="title warning">警告</div>
              <div class="value">{{count.urgent}}<span class="unit">个</span></div>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="conent border-none">
              <div class="title default">一般</div>
              <div class="value">{{count.generally}}<span class="unit">个</span></div>
            </div>
          </el-col>
        </el-row>
      </div>
      <el-table :data="dataList" border style="width: 100%" v-loading="tableLoading">
        <el-table-column
          type="index"
          align="center"
          width="50"
          fixed
        ></el-table-column>
        <el-table-column
          prop="serialId"
          header-align="center"
          width="200"
          align="center"
          label="编号"
        >
        </el-table-column>
        <el-table-column
          prop="subject"
          header-align="center"
          width="200"
          align="center"
          label="通报名称"
        >
        </el-table-column>
        <el-table-column
          prop="updateAt"
          header-align="center"
          width="200"
          align="center"
          label="更新时间"
        >
        </el-table-column>
        <el-table-column
          prop="securityDetailText"
          header-align="center"
          align="center"
          label="详情"
        >
        </el-table-column>
      </el-table>
      <el-pagination
        :current-page="page.page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="page.limit"
        :total="page.total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="pageSizeChangeHandle"
        @current-change="pageCurrentChangeHandle">
      </el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  name: 'modularChild8',
  props: ['socUserName'],
  data () {
    return {
      radio: 1,
      dataList: [],
      chartLoading: false,
      tableLoading: false,
      username: '',
      count: {
        alert: 0,
        urgent: 0,
        generally: 0
      },
      page: {
        page: 1,
        limit: 10,
        total: 0
      }
    }
  },
  methods: {
    getData (socUserName) {
      if (socUserName === undefined) {
        socUserName = this.socUserName
      }
      this.chartLoading = true
      let params = {
        username: socUserName
      }
      this.$http.post(`/front/consumer/order/soc/interface/queryBriefing`, params)
        .then(({ data }) => {
          if (data.code === 0) {
            this.count.alert = data.data.alert || 0
            this.count.urgent = data.data.urgent || 0
            this.count.generally = data.data.generally || 0
          }
          this.chartLoading = false
        })
        .catch(() => {
          this.chartLoading = false
        })
    },
    getTabelData () {
      this.tableLoading = true
      let params = {
        offset: this.page.page,
        limit: this.page.limit,
        username: this.socUserName
      }
      this.$http.post(`/front/consumer/order/soc/interface/queryLastDynamic`, params)
        .then(({ data }) => {
          if (data.code === 0) {
            this.dataList = data.data.records
            this.page.total = data.data.total
          }
          this.tableLoading = false
        })
        .catch(() => {
          this.tableLoading = false
        })
    },
    formatterData (data) {
      return []
    },
    // 每页数
    pageSizeChangeHandle (val) {
      this.page.limit = val
      this.page.page = 1
      this.getTabelData()
    },
    // 当前页
    pageCurrentChangeHandle (val) {
      this.page.page = val
      this.getTabelData()
    }
  },
  mounted () {
    this.getData()
    this.getTabelData()
  }
}
</script>

<style lang="scss" scoped>
.modular {
  position: relative;
  .radiobox {
    pointer-events: none;
    width: 100%;
    position: absolute;
    top: -30px;
    .radio {
      pointer-events: auto;
      width: 100px;
      margin: 0 auto;
    }
  }
  .echarts {
    height: calc(100vh - 370px);
  }
  .top {
    margin: 20px;
    padding: 20px;
    border: 1px solid #ccc;
    border-radius: 8px;
    .conent {
      margin: 0 auto;
      text-align: center;
      border-right: 1px solid #ccc;
      .title {
        font-size: 24px;
        font-weight: bold;
        margin-bottom: 20px;
      }
      .value {
        font-size: 26px;
        font-weight: bold;
        .unit {
          margin-left: 6px;
          font-size: 14px;
        }
      }
      .warning {
        color: #E6A23C;
      }
      .danger {
        color: #F56C6C;
      }
      .default {
        color: #409EFF;
      }
    }
    .border-none {
      border-right: none;
    }
  }
}
</style>
